import styled from "@emotion/styled"

export default styled.section`
  /* color: white; */
  /* Pass variables as inputs */
  color: ${props => props.color || "white"};

  /* Pass variables as inputs */
  padding: ${props => props.padding};

  /* Adjust the background from the properties */
  background: ${props => props.background || "#0066f5"};

  /* Adjust the border from the properties */
  border: ${props => props.border || "none"};

  /* Adjust the width from the properties */
  width: ${props => props.width || "100%"};
`
